import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { Selfie } from 'page/ProfileScreen/Selfies/Selfie'
import { SelfieBanner } from 'page/ProfileScreen/Selfies/SelfieBanner'
import css from 'page/ProfileScreen/Selfies/Selfies.module.scss'
import { store } from 'store/store'

export const Selfies = observer(() => {
  const { both, banner } = store.profile.common

  return (
    <>
      <Space className={css.selfies} center>
        <Selfie num={0} />
        {both && <Selfie num={1} />}
      </Space>
      {banner !== 'close' && <SelfieBanner />}
    </>
  )
})
